import React from "react";
import {SvgIcon, SvgIconProps} from "@material-ui/core"


const CheckIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg version="1.1" id="Layer_1" x="0px" y="0px"
                 viewBox="0 0 512 512">
<path id="Path_541" fill="#FFFFFF;stroke:#FFFFFF;stroke-width:0.7;" d="M156.227,446.415h-0.538
	c-7.028-0.132-13.7-3.118-18.482-8.269L6.842,296.575c-9.682-10.516-9.007-26.89,1.509-36.573c0.007-0.006,0.014-0.013,0.021-0.019
	c10.533-9.667,26.903-8.982,36.591,1.53l112.09,121.765L467.771,73.181c10.1-10.116,26.488-10.129,36.604-0.029
	c0.009,0.009,0.02,0.019,0.029,0.029c10.116,10.1,10.129,26.488,0.029,36.604c-0.009,0.009-0.02,0.019-0.029,0.029l-329.82,328.952
	C169.725,443.654,163.119,446.407,156.227,446.415z"/>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
                <g>
</g>
</svg>
        </SvgIcon>
    )
};

export default CheckIcon;